import { useCallback, useEffect, useState } from 'react';

import { translateUnitTitle } from '../data/api';

const useUnitTitle = ({
  courseId,
  selectedLanguage,
  unitId,
  unitTitle,
  courseLanguage = 'en',
}) => {
  const [currentTitle, setCurrentTitle] = useState(unitTitle);
  const [currentSelectedLanguage, setCurrentSelectedLanguage] = useState('');

  const translateUnitTitleRequest = useCallback(async () => {
    const data = await translateUnitTitle({
      content: unitTitle,
      courseId,
      sourceLanguage: courseLanguage,
      sourceTypeId: unitId,
      targetLanguage: selectedLanguage,
    });
    setCurrentTitle(data?.translatedContent ?? unitTitle);
  }, [
    courseId,
    selectedLanguage,
    unitId,
    unitTitle,
  ]);

  useEffect(() => {
    const request = async () => {
      const domNode = document.querySelector('.unit .h3');
      if (domNode && selectedLanguage !== courseLanguage) {
        setCurrentSelectedLanguage(selectedLanguage);
        if (currentSelectedLanguage !== selectedLanguage) {
          await translateUnitTitleRequest(domNode);
        }
        domNode.textContent = currentTitle;
      } else if (domNode) {
        domNode.textContent = unitTitle;
      }
    };

    if (unitTitle) {
      request();
    }
  }, [selectedLanguage, currentTitle]);
};

export default useUnitTitle;
